(function () {
  function initDehumidifierCarousel(root) {
    if (!root || root.dataset.initialized === 'true') return;

    var slidesData = [
      { title: 'Crawl Spaces', description: 'Dry crawl spaces areas, shield home structure from damage', image: 'https://cdn.shopify.com/s/files/1/0673/1045/3041/files/Rectangle_34625263.png?v=1756791622', product_image: 'https://cdn.shopify.com/s/files/1/0673/1045/3041/files/image_2926_4.png?v=1756792908', product_name: 'AlorAir 120 PPD Crawl Space Dehumidifier with Pump and Drain Hose | Sentinel HD55P | Size for 1500 sq.ft', product_price: '$594.71 USD', product_original_price: '$699.66 USD', product_url: 'https://aloraircrawlspace.com/products/alorair-120-pint-crawl-space-dehumidifier-sentinel-hd55p?_pos=1&_psq=AlorAir+120+PPD+Crawl+Space+Dehumidifier+with+Pump+and+Drain+Hose+%7C+Sentinel+HD55P+%7C+Size+for+1500+sq.ft&_ss=e&_v=1.0' },
      { title: 'Mold Removal', description: 'Cut moisture, stop mold growth, restore clean spaces', image: 'https://cdn.shopify.com/s/files/1/0673/1045/3041/files/ea9197e3553e97e5e9b4a1d71129c529.png?v=1756791620', product_image: 'https://cdn.shopify.com/s/files/1/0673/1045/3041/files/image_2926_9.png?v=1756793134', product_name: 'AlorAir WiFi 198 PPD Crawl Space Dehumidifier with Condensate Pump | Sentinel HDi90 Wifi | Size for 2600 sq.ft', product_price: '$1,279.11 USD', product_original_price: '', product_url: 'https://aloraircrawlspace.com/products/alorair-wifi-198-ppd-crawl-space-dehumidifier-with-condensate-pump-sentinel-hdi90-wifi-size-for-2600-sq-ft?_pos=1&_psq=AlorAir+WiFi+198+PPD+Crawl+Space+Dehumidifier+with+Condensate+Pump+%7C+Sentinel+HDi90+Wifi+%7C+Size+for+2600+sq.ft&_ss=e&_v=1.0' },
      { title: 'Carpet Cleaning', description: 'Speed drying, prevent mold, maintain freshness', image: 'https://cdn.shopify.com/s/files/1/0673/1045/3041/files/1_4bb3e35f-f242-45ac-bfa2-8dee81721117.png?v=1756791621', product_image: 'https://cdn.shopify.com/s/files/1/0673/1045/3041/files/image_2926_5.png?v=1756792908', product_name: 'AlorAir 113 PPD Crawl Space Dehumidifiers with Drain Hose | Sentinel HD55 (Blue) | Size for 1200 sq.ft', product_price: '$469.99 USD', product_original_price: '$587.48 USD', product_url: 'https://aloraircrawlspace.com/products/alorair-113-ppd-crawl-space-dehumidifiers-sentinel-hd55-blue?_pos=1&_psq=AlorAir+113+PPD+Crawl+Space+Dehumidifiers+with+Drain+Hose+%7C+Sentinel+HD55+%28Blue%29+%7C+Size+for+1200+sq.ft&_ss=e&_v=1.0' },
      { title: 'Basements', description: 'Make damp basements usable, fresh living/storage spaces', image: 'https://cdn.shopify.com/s/files/1/0673/1045/3041/files/2_9e572c99-8e64-4f1d-9fb5-a3859fa9509c.png?v=1756791621', product_image: 'https://cdn.shopify.com/s/files/1/0673/1045/3041/files/image_2926_6.png?v=1756792908', product_name: 'AlorAir 120 PPD Crawl Space Dehumidifiers with Drain Hose | Sentinel HD55S (White) | Size for 1300 sq.ft', product_price: '$518.93 USD', product_original_price: '$648.66 USD', product_url: 'https://aloraircrawlspace.com/products/alorair-120-ppd-crawl-space-dehumidifiers-sentinel-hd55-white?_pos=1&_psq=AlorAir+120+PPD+Crawl+Space+Dehumidifiers+with+Drain+Hose+%7C+Sentinel+HD55S+%28White%29+%7C+Size+for+1300+sq.ft&_ss=e&_v=1.0' },
      { title: 'Warehouse', description: 'Control large-area humidity, guard stored goods safely', image: 'https://cdn.shopify.com/s/files/1/0673/1045/3041/files/3_40ff1b8e-6645-4bd6-8691-1f9c334484d0.png?v=1756791622', product_image: 'https://cdn.shopify.com/s/files/1/0673/1045/3041/files/image_2926_7.png?v=1756792908', product_name: 'AlorAir 235 PPD Crawl Space Dehumidifier with Pump and Drain Hose | Sentinel HDi120 (White) | Size for 3300 sq.ft', product_price: '$1,439.00 USD', product_original_price: '$1,599.00 USD', product_url: 'https://aloraircrawlspace.com/products/alorair-235-ppd-crawl-space-dehumidifier-sentinel-hdi120-white?_pos=1&_psq=AlorAir+235+PPD+Crawl+Space+Dehumidifier+with+Pump+and+Drain+Hose+%7C+Sentinel+HDi120+%28White%29+%7C+Size+for+3300+sq.ft&_ss=e&_v=1.0' },
      { title: 'Office & Workplace', description: 'Ease air, lift comfort, boost staff work efficiency', image: 'https://cdn.shopify.com/s/files/1/0673/1045/3041/files/4_102a3ecd-fbd2-4cbd-b1b5-2bc68c4ffb1d.png?v=1756791624', product_image: 'https://cdn.shopify.com/s/files/1/0673/1045/3041/files/image_2926_8.png?v=1756792909', product_name: 'AlorAir 180 Pint Crawlspace Dehumidifiers with Pump and Drain Hose | Galaxy 85P | Size for 2,300 Sq.Ft', product_price: '$899.11 USD', product_original_price: '', product_url: 'https://aloraircrawlspace.com/products/crawlspace-dehumidifiers-with-pump-and-drain-hose-galaxy-85p?_pos=1&_psq=AlorAir+180+Pint+Crawlspace+Dehumidifiers+with+Pump+and+Drain+Hose+%7C+Galaxy+85P+%7C+Size+for+2%2C300+Sq.Ft&_ss=e&_v=1.0' }
    ];

    var currentSlide = 0;
    var totalSlides = slidesData.length;
    var imageCache = {};
    var svgIcon = {
      left: '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><path d="M45.2531 24.7264C45.2531 36.2186 35.9361 45.5348 24.4429 45.5348C12.9498 45.5348 3.63281 36.2186 3.63281 24.7264C3.63281 13.2342 12.9498 3.91797 24.4429 3.91797C35.9361 3.91797 45.2531 13.2342 45.2531 24.7264Z" fill="#21467A" fill-opacity="0.1"/><path d="M27.875 17.1427L19.7445 25.2725L27.875 33.4023" stroke="#21467A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      right: '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><path d="M45.2531 24.7264C45.2531 36.2186 35.9361 45.5348 24.4429 45.5348C12.9498 45.5348 3.63281 36.2186 3.63281 24.7264C3.63281 13.2342 12.9498 3.91797 24.4429 3.91797C35.9361 3.91797 45.2531 13.2342 45.2531 24.7264Z" fill="#21467A" fill-opacity="0.1"/><path d="M22.125 32.8573L30.2555 24.7275L22.125 16.5977" stroke="#21467A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };

    var elements = {
      leftImage: root.querySelector('#leftImage'),
      centerImage: root.querySelector('#centerImage'),
      rightImage: root.querySelector('#rightImage'),
      leftTitle: root.querySelector('#leftTitle'),
      centerTitle: root.querySelector('#centerTitle'),
      rightTitle: root.querySelector('#rightTitle'),
      leftDescription: root.querySelector('#leftDescription'),
      centerDescription: root.querySelector('#centerDescription'),
      rightDescription: root.querySelector('#rightDescription'),
      productCard: root.querySelector('#productCard'),
      productImage: root.querySelector('#productImage'),
      productName: root.querySelector('#productName'),
      productPrice: root.querySelector('#productPrice'),
      productOriginalPrice: root.querySelector('#productOriginalPrice'),
      buyNowBtn: root.querySelector('#buyNowBtn'),
      carousel: root.querySelector('#carousel')
    };

    if (!elements.carousel || !elements.centerImage) return;

    root.dataset.initialized = 'true';

    var buttons = [
      root.querySelector('#prevBtn_swiper'),
      root.querySelector('#nextBtn_swiper'),
      root.querySelector('#prevBtn_mobile'),
      root.querySelector('#nextBtn_mobile')
    ];

    function preloadImage(src, key) {
      return new Promise(function (resolve) {
        if (imageCache[key]) return resolve(imageCache[key]);
        var img = new Image();
        img.onload = function () {
          imageCache[key] = img;
          resolve(img);
        };
        img.onerror = function () {
          console.warn('Failed to load image: ' + src);
          resolve(null);
        };
        img.src = src;
      });
    }

    function preloadImages() {
      return Promise.all(slidesData.map(function (slide, index) {
        return Promise.all([
          preloadImage(slide.image, 'slide_' + index),
          slide.product_image ? preloadImage(slide.product_image, 'product_' + index) : Promise.resolve()
        ]);
      }));
    }

    function updateProgressBar() {
      root.querySelectorAll('.dehumidifier-carousel-progress-segment').forEach(function (segment, index) {
        segment.classList.toggle('active', index === currentSlide);
      });
    }

    function updateButtonStates() {
      buttons.forEach(function (btn, i) {
        if (!btn) return;
        btn.innerHTML = i % 2 === 0 ? svgIcon.left : svgIcon.right;
        btn.disabled = false;
      });
    }

    function updateCarousel(isInitial) {
      var indices = [
        (currentSlide - 1 + totalSlides) % totalSlides,
        currentSlide,
        (currentSlide + 1) % totalSlides
      ];
      var leftIndex = indices[0];
      var centerIndex = indices[1];
      var rightIndex = indices[2];

      Object.keys(elements).forEach(function (key) {
        var el = elements[key];
        if (el && el.classList) el.classList.remove('animate-in');
      });

      function updateSlide(index, prefix) {
        var slide = slidesData[index];
        var img = elements[prefix + 'Image'];
        var cached = imageCache['slide_' + index];
        if (img) {
          img.src = cached ? cached.src : slide.image;
          img.alt = slide.title;
        }
        if (elements[prefix + 'Title']) elements[prefix + 'Title'].textContent = slide.title;
        if (elements[prefix + 'Description']) elements[prefix + 'Description'].textContent = slide.description;
      }

      updateSlide(leftIndex, 'left');
      updateSlide(centerIndex, 'center');
      updateSlide(rightIndex, 'right');

      var p = slidesData[centerIndex];
      var hasProduct = p.product_name || p.product_image || p.product_price;
      if (hasProduct && elements.productCard) {
        elements.productCard.style.display = 'flex';
        var productCached = imageCache['product_' + centerIndex];
        if (elements.productImage) elements.productImage.src = productCached ? productCached.src : (p.product_image || '');
        if (elements.productName) elements.productName.textContent = p.product_name || '';
        if (elements.productPrice) elements.productPrice.textContent = p.product_price || '';
        if (elements.productOriginalPrice) {
          elements.productOriginalPrice.style.display = p.product_original_price ? '' : 'none';
          elements.productOriginalPrice.textContent = p.product_original_price || '';
        }
        if (elements.buyNowBtn) elements.buyNowBtn.disabled = !p.product_url;
        var goToProduct = p.product_url ? function () { window.location.href = p.product_url; } : null;
        if (elements.buyNowBtn) elements.buyNowBtn.onclick = goToProduct;
        elements.productCard.onclick = goToProduct;
        elements.productCard.style.cursor = p.product_url ? 'pointer' : 'default';
      } else if (elements.productCard) {
        elements.productCard.style.display = 'none';
      }

      updateProgressBar();
      updateButtonStates();

      setTimeout(function () {
        requestAnimationFrame(function () {
          [elements.leftImage, elements.centerImage, elements.rightImage].forEach(function (el) {
            if (el) el.classList.add('animate-in');
          });

          var timings = [
            [200, [elements.centerTitle]],
            [500, [elements.centerDescription]],
            [800, hasProduct ? [elements.productCard] : []],
            [1000, [elements.leftTitle, elements.rightTitle]],
            [1200, [elements.leftDescription, elements.rightDescription]]
          ];

          timings.forEach(function (pair) {
            setTimeout(function () {
              pair[1].forEach(function (el) {
                if (el) el.classList.add('animate-in');
              });
            }, pair[0]);
          });
        });
      }, isInitial ? 300 : 0);
    }

    function nextSlide() {
      currentSlide = (currentSlide + 1) % totalSlides;
      updateCarousel(false);
    }

    function previousSlide() {
      currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
      updateCarousel(false);
    }

    var progressBar = root.querySelector('#progressBar');
    if (progressBar) {
      progressBar.addEventListener('click', function (e) {
        var segment = e.target.closest('.dehumidifier-carousel-progress-segment');
        if (!segment) return;
        var slideIndex = parseInt(segment.getAttribute('data-slide'), 10);
        if (slideIndex !== currentSlide) {
          currentSlide = slideIndex;
          updateCarousel(false);
        }
      });
    }

    var leftCard = root.querySelector('#leftCard');
    var rightCard = root.querySelector('#rightCard');
    if (leftCard) leftCard.addEventListener('click', previousSlide);
    if (rightCard) rightCard.addEventListener('click', nextSlide);
    if (buttons[0]) buttons[0].addEventListener('click', previousSlide);
    if (buttons[1]) buttons[1].addEventListener('click', nextSlide);
    if (buttons[2]) buttons[2].addEventListener('click', previousSlide);
    if (buttons[3]) buttons[3].addEventListener('click', nextSlide);

    var startX = 0;
    var isDragging = false;
    var startTime = 0;
    elements.carousel.style.cursor = 'grab';

    function handleStart(e) {
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      isDragging = true;
      startTime = Date.now();
      if (e.cancelable) e.preventDefault();
      elements.carousel.style.cursor = 'grabbing';
      elements.carousel.style.userSelect = 'none';
    }

    function handleEnd(e) {
      if (!isDragging) return;
      isDragging = false;
      elements.carousel.style.cursor = 'grab';
      elements.carousel.style.userSelect = '';
      var endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
      var deltaX = endX - startX;
      var deltaTime = Date.now() - startTime;
      if (Math.abs(deltaX) >= 50 && deltaTime <= 300) {
        if (deltaX > 0) previousSlide();
        else nextSlide();
      }
    }

    elements.carousel.addEventListener('mousedown', handleStart, { passive: false });
    elements.carousel.addEventListener('mousemove', function (e) {
      if (isDragging && e.cancelable) e.preventDefault();
    }, { passive: false });
    elements.carousel.addEventListener('mouseup', handleEnd, { passive: false });
    elements.carousel.addEventListener('mouseleave', handleEnd, { passive: false });

    preloadImages().then(function () {
      updateCarousel(true);
    }).catch(function () {
      updateCarousel(true);
    });
  }

  function boot() {
    document.querySelectorAll('.dehumidifier-carousel-container-wait').forEach(initDehumidifierCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
